import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from 'helpers';
import style from './TripDistributionBar.module.css';

const CONST_MAX_VALUE = 500;

const TripDistributionChartItem = ({ value, color, className, isInline, totalValue }) => {
  const minWidth = 5; // Minimum width in percentage (e.g., 5%)

  const calculateWidth = () => {
    if (value === 0) return 0;

    if (isInline && totalValue !== undefined) {
      // For inline items, calculate proportional width based on parent's total value
      const totalWidth = Math.min((totalValue / CONST_MAX_VALUE) * (100 - minWidth) + minWidth, 100);
      return (value / totalValue) * totalWidth; // Exact proportion without extra minWidth
    }

    // Standard calculation for the total or if no total value is provided
    const proportionalWidth = (value / CONST_MAX_VALUE) * (100 - minWidth);
    return Math.min(proportionalWidth + minWidth, 100);
  };

  return (
    value > 0 && (
      <div
        className={`${style['trip-bar-cell']} ${className}`}
        style={{
          width: `${calculateWidth()}%`,
          backgroundColor: color,
        }}
      >
        <strong className={style['trip-bar-label']}>{formatNumber(value)}</strong>
      </div>
    )
  );
};

TripDistributionChartItem.defaultProps = {
  value: null,
  color: null,
  className: null,
  isInline: false,
  totalValue: null,
};

TripDistributionChartItem.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  isInline: PropTypes.bool,
  totalValue: PropTypes.number,
};

export default TripDistributionChartItem;
